import classnames from 'classnames';
import styles from './LoadingStatus.scss';

export function LoadingStatus({ filterQuery, currentItemCount, totalItemCount, itemName, loading, actionLabel = 'loading', className }) {

    if (loading) {
        return (
            <Spinner actionLabel={actionLabel} itemName={itemName} className={className} data-cy="LoadingStatus" />
        );
    }

    if (!currentItemCount) {
        return null;
    }

    const actionName = filterQuery ? 'Filter matches' : 'Showing';
    const countMessage = totalItemCount
        ? `${currentItemCount} of ${totalItemCount}`
        : `${currentItemCount}`;
    return (
        <div className={styles.caption} data-cy="LoadingStatus-return">
            <p className={styles.caption__text} data-cy="LoadingStatus-actionName">
                {actionName}
                <span className={styles.caption__text__count} data-cy="LoadingStatus-countMessage">{countMessage}</span>
                {itemName}
            </p>
        </div>
    );
}

export function Spinner({ itemName, actionLabel, className }) {
    return (
        <div className={styles.caption} data-cy="LoadingStatus-Spinner">
            <p className={styles.caption__text} data-cy="LoadingStatus-text">{actionLabel} {itemName}</p>
            <div className={styles.spinner}>
                <div className={classnames(styles.spinner__mask, className)}></div>
            </div>
        </div>
    );
}

export function SpinnerMini({ extraSmall = false, className }) {
    return (
        <div className={
            classnames(
                styles.spinner_mini,
                { [styles.extra_small]: extraSmall }
            )}
        data-cy="LoadingStatus-SpinnerMini"
        >
            <div className={classnames(styles.spinner__mask_mini, className)}></div>
        </div>
    );
}
